import noop from 'lodash/noop';
import { createContext } from 'react';

import type { useMenu } from 'shared/components/Menu/hooks';

export type Context = ReturnType<typeof useMenu>;

export const context = createContext<Context>({
  open: false,
  onOpen: noop,
  onClose: noop,
  anchorEl: null,
});

export const { Provider } = context;
